import { restApiMP } from "@plannel/services/utils/rest-api";

// 공급계획 수요 제약 설정 — 기준일자 시점의 재고 조회
// 조회 대상 품목은 itemCd 자체가 아니라 itemCd 의 BOM 구성품(반제품/원자재)이다.
// params: { baseDate(필수, Date|yyyy-MM-dd), locCd(필수), itemCd(필수) }
const getInventoryData = (params) => {
  return restApiMP.get("/api/mp-demand-constraint/inventory-data", { params });
};

// 거점·품목 기준 재공 조회 — 요청 품목 자체의 생산 중 물량(BOM 전개 없음)
// params: { locCd(필수), itemCd(필수) }
const getWipData = (params) => {
  return restApiMP.get("/api/mp-demand-constraint/wip-data", { params });
};

// 주문 품목의 생산 공정 조회 — 거점에 생산 자원이 1개 이상 있는 공정만
// params: { locCd(필수), itemCd(필수) }
const getRouteData = (params) => {
  return restApiMP.get("/api/mp-demand-constraint/route-data", { params });
};

// 생산 자원을 지정할 공정 목록 — 대체 자원(자원 2개 이상)이 있는 공정만
// params: { locCd(필수), itemCd(필수) }
const getResourceRouteData = (params) => {
  return restApiMP.get("/api/mp-demand-constraint/resource-route-data", { params });
};

// 선택된 공정의 생산 자원(대체 자원 포함) 조회
// params: { locCd(필수), routeCdList(필수, string[]) }
const getResourceData = (params) => {
  return restApiMP.get("/api/mp-demand-constraint/resource-data", { params });
};

// 완제품 1개당 구성품(반제품/원자재) 투입 수량 비율 — 할당 수량의 완제품 환산·자재별 상한 계산용
// params: { itemCd(필수) }
const getBomRatio = (params) => {
  return restApiMP.get("/api/mp-demand-constraint/bom-ratio", { params });
};

// 수요 1건의 할당 정보 저장 — alloc_obj 에 { inventory: [...], wip: [...], route: [...], resource: [...] } 로 저장된다
// inventory 항목: { invId, locCd, itemCd, availDate, availQty, allocQty, activeFlg }
//   availDate 는 가용해지는 일자 — ON_HAND 는 실적 일자, IN_TRANSIT 은 도착 일자가 들어간다
// wip 항목: { wipId, locCd, wcCd, itemCd, routeCd, resCd, prodDate, availQty, allocQty, activeFlg }
// payload: { parPlanVerId, locCd, itemCd, dueDate, orderType, reqLocCd, customerCd, orderQty, inventory, wip, route, resource }
const saveAllocation = (payload) => {
  return restApiMP.post("/api/mp-demand-constraint/allocation", payload);
};

// 저장된 재고 할당 내역 조회 — 팝업 초기 설정용. 조회 키(요청 거점/거래처)에 null 이 섞여
// 쿼리스트링 직렬화가 애매해지므로 body 로 보낸다.
// payload: { parPlanVerId, locCd, itemCd, dueDate, orderType, reqLocCd, customerCd }
const getAllocation = (payload) => {
  return restApiMP.post("/api/mp-demand-constraint/allocation/search", payload);
};

// 같은 수요 버전의 "다른" 수요들이 재고/재공 lot 에 이미 할당한 수량 조회 —
// lot 하나가 여러 수요에 중복 할당되지 않도록 가용 수량에서 차감하는 데 쓴다.
// 응답: { results: { inventory: { [invId]: qty }, wip: { [wipId]: qty } } } (없으면 204)
// payload: getAllocation 과 동일한 수요 키
const getOtherAllocation = (payload) => {
  return restApiMP.post("/api/mp-demand-constraint/allocation/others", payload);
};

const mpDemandConstraintService = {
  getInventoryData,
  getWipData,
  getRouteData,
  getResourceRouteData,
  getResourceData,
  getBomRatio,
  getAllocation,
  getOtherAllocation,
  saveAllocation
};

export default mpDemandConstraintService;
